<script lang="ts">
    import { onMount } from "svelte";
    import Container from "../../../../components/Container.svelte";
    import Gap from "../../../../components/Gap.svelte";
    import LightTheme from "../../../../components/LightTheme.svelte";
    import type { News } from "../../../../components/NewsCard.svelte";
    import PageTransition from "../../../../components/PageTransition.svelte";
    import Image from "../../../../components/Image.svelte";
    import Hero from "../../../../components/Hero.svelte";
    import IdeaInfo from "../../../../components/IdeaInfo.svelte";
    import Divider from "../../../../components/Divider.svelte";
    import Headline from "../../../../components/Headline.svelte";
    import Subline from "../../../../components/Subline.svelte";

    import { params } from "@roxi/routify";
    import { getLocaleByInt, t } from "../../../../helpers/translation";

    type News = {
        id: number;
        url: string;
        title: string;
        subline: string;
        image: string;
        date: Date;
        bodyhtml: string;
        shortbodyhtml: string;
        iframehtml: string;
        dark: boolean;
        hidden: boolean;
    };

    function loadNewsData(): Promise<News> {
        return fetch(`/api/NewsSelectPublic`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: Number.parseInt($params.id),
                lang: getLocaleByInt(),
            }),
        })
            .then((data) => data.json())
            .then((data: News) => {
                console.log(data);
                return data;
            });
    }
</script>

<LightTheme />

{#await loadNewsData()}
    {$t("fetch.post.loading")}
{:then data}
    <Hero
        small
        bgimg={data.image ||
            "https://liveicom.azureedge.net/sinus/img/hero-wave-green.jpg"}
        aspectRatio="16 / 9"
    />

    <Container>
        <Headline>{data.title}</Headline>
        {#if data.subline}
            <Subline>{data.subline}</Subline>
        {/if}
        <Divider gap="2rem" />
        <time>{new Date(data.date).toLocaleDateString()}</time>
        <article>
            {@html data.bodyhtml ?? "kein inhalt"}
        </article>

        <!-- <IdeaInfo>hier dann andere beiträge verlinken??</IdeaInfo> -->
    </Container>
{:catch}
    {$t("fetch.post.error")}
{/await}

<style lang="scss">
    @import "../../../../vars";

    h1 {
        font-size: 2.5rem;
        font-weight: 600;
        line-height: 1.2;
    }
</style>
